module.exports = __webpack_public_path__ + "img/AdobeStock_28006614.c5ea7c2a.jpeg";